import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';

@customElement('claims-popup')
export class ClaimsPopup extends DeviceAwareComponent {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        #art {
          width: 66%;
          height: 30rem;
        background-image: url(./assets/we-got-it-popup.svg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .title{
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
      }
      .message{
        font-weight: var(--font-weight-emphasize);
        padding-inline: 2rem;
      }
      @media screen and  (max-width: 370px) {
        #art {
          height: 25rem;
        }
      }
    `,
    ];
  };

  render() {
    return html`
      <h1 class="title">${t('T_Claims_Title')}</h1>
      <div id="art"></div>  
      <p class="message">${t('T_Claims_Text')}</p>
    `;
  }
}
